import { GoogleLogin, GoogleOAuthProvider } from '@react-oauth/google';
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { useEffect, useState } from "react";
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { useNavigate } from "react-router-dom";
import { useAuth } from "../AuthContext";
import logo from "../images/dc_logo.png";
import loginvc from "../images/loginbg.jpg";

// const BASE_URL = "http://localhost:8000";
const BASE_URL = "https://idealpursuits.co.in/api";

function Register() {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [otp, setOtp] = useState("");
    const [otpSent, setOtpSent] = useState(false);
    const [otpVerified, setOtpVerified] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const { login } = useAuth();
    const navigate = useNavigate();
    const [otpButtonDisabled, setOtpButtonDisabled] = useState(false);
    const [otpButtonText, setOtpButtonText] = useState("Verify");
    const [countdown, setCountdown] = useState(0);
    const [showPassword, setShowPassword] = useState(false);

    useEffect(() => {
        const userData = localStorage.getItem("userData");
        if (userData) {
            navigate("/");
        }
    }, [navigate]);

    useEffect(() => {
        let timer;
        if (countdown > 0) {
            timer = setTimeout(() => setCountdown(countdown - 1), 1000);
        } else if (countdown === 0 && otpSent) {
            setOtpButtonText("Resend OTP");
            setOtpButtonDisabled(false);
        }
        return () => clearTimeout(timer);
    }, [countdown, otpSent]);

    const handleSendOtp = async () => {
        setOtpButtonDisabled(true);
        setOtpButtonText("Sending...");

        try {
            const response = await axios.post(`${BASE_URL}/otp.php`, { email });
            if (response.data.success) {
                setOtpSent(true);
                setCountdown(60);
                setSuccessMessage("OTP sent to your email. Please check your inbox.");
            } else {
                alert(response.data.error || "Failed to send OTP. Please try again.");
                setOtpButtonDisabled(false);
                setOtpButtonText("Verify");
            }
        } catch (error) {
            console.error("Error sending OTP:", error);
            alert("Something went wrong. Please try again.");
            setOtpButtonDisabled(false);
            setOtpButtonText("Verify");
        }
    };

    const handleVerifyOtp = async () => {
        try {
            const response = await axios.post(`${BASE_URL}/verifyOTP.php`, { email, otp });
            if (response.data.success) {
                setOtpVerified(true);
                setOtpButtonDisabled(true);
                setOtpButtonText('Verified')
                setCountdown(0);
                setSuccessMessage("OTP verified successfully.");
                setErrorMessage("");
            } else {
                setErrorMessage("Invalid OTP. Please try again.");
                setOtpButtonDisabled(false);
                setOtpButtonText("Verify");
            }
        } catch (error) {
            console.error("Error sending OTP:", error);
            alert("Something went wrong. Please try again.");
            setOtpButtonDisabled(false);
            setOtpButtonText("Verify");
        }
    };

    const handleRegister = async (e) => {
        e.preventDefault();
        setErrorMessage("");
        setSuccessMessage("");

        if(!otpVerified){
            setErrorMessage("Verify your Email ID!")
            return;
        }

        if(!password || !confirmPassword){
            setErrorMessage("Password fields cannot be empty.");
            return;
        }
        
        if (password !== confirmPassword) {
            setErrorMessage("Passwords do not match.");
            return;
        }

        try {
            const response = await axios.post(`${BASE_URL}/register.php`, {
                name,
                email,
                password
            });
            const data = response.data;

            if (data.success) {
                login(data.user);
                alert("Registration successful!");
                navigate("/");
            } else {
                setErrorMessage(data.error || "Failed to register. Please try again.");
            }
        } catch (error) {
            console.error("Error during registration:", error);
            setErrorMessage("Something went wrong. Please try again.");
        }
    };

    const handleGoogleSuccess = async (credentialResponse) => {
        try {
            const decoded = jwtDecode(credentialResponse.credential);
            const response = await axios.post(`${BASE_URL}/google_login.php`, {
                email: decoded.email,
                name: decoded.name,
                google_id: decoded.sub
            });

            const data = response.data;

            if (data.success) {
                login(data.user);
                alert("Registration successful!");
                navigate("/");
            } else {
                setErrorMessage(data.error || "Google registration failed. Please try again.");
            }
        } catch (error) {
            console.error("Google registration error:", error);
            setErrorMessage("Something went wrong with Google registration. Please try again.");
        }
    };

    const handleGoogleError = () => {
        setErrorMessage("Google registration failed. Please try again.");
    };

    return (
        <GoogleOAuthProvider clientId="987740287283-ba8246b7otfcnb9eqk3obe5u675i8vfe.apps.googleusercontent.com">
            <div className="login-bg">
                <div className="login-container">
                    <div className="login-box">
                        <div className="logo">
                            <img src={logo} alt="Logo" />
                        </div>
                        <form className="login-form" onSubmit={handleRegister}>
                            <h1>Register</h1>
                            <div className="google-login-container">
                                <p>Quick registration with:</p>
                                <GoogleLogin
                                    onSuccess={handleGoogleSuccess}
                                    onError={handleGoogleError}
                                />
                            </div>
                            <br />
                            <div className="separator">
                                <span>or register:</span>
                            </div>
                            <br />
                            {/* Rest of the form remains the same */}
                            <div className="input-group">
                                <label htmlFor="name">Name</label>
                                <input
                                    id="name"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    placeholder="Enter your name"
                                    required
                                />
                            </div>
                            <div className="input-group">
                                <label htmlFor="email">Email</label>
                                <div className="email-verify">
                                    <input
                                        type="email"
                                        id="email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        placeholder="Enter your email"
                                        required
                                        disabled={otpVerified}
                                    />
                                    {!otpVerified &&
                                        <button
                                            type="button"
                                            onClick={handleSendOtp}
                                            disabled={otpButtonDisabled}
                                        >
                                            {countdown > 0 ? `Resend OTP in ${countdown}s` : otpButtonText}
                                        </button>
                                    }
                                </div>
                            </div>
                            {otpSent && !otpVerified && (
                                <div className="input-group">
                                    <label htmlFor="otp">Enter OTP</label>
                                    <input
                                        type="number"
                                        id="otp"
                                        value={otp}
                                        onChange={(e) => setOtp(e.target.value)}
                                        placeholder="Enter OTP"
                                        required
                                    />
                                    <button type="button" onClick={handleVerifyOtp} disabled={otpVerified}>
                                        Verify OTP
                                    </button>
                                </div>
                            )}
                            <div className="input-group">
                                <label htmlFor="password">Password</label><div className="email-verify">
                                    <input
                                        type={showPassword ? "text" : "password"}
                                        id="password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        placeholder="Enter your password"
                                    />
                                    <button
                                        type="button"
                                        className="show-password-btn"
                                        onClick={() => setShowPassword(!showPassword)}
                                    >
                                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                                    </button>
                                </div>
                            </div>
                            <div className="input-group">
                                <label htmlFor="confirmPassword">Confirm Password</label>
                                <input
                                    type="password"
                                    id="confirmPassword"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    placeholder="Confirm your password"
                                />
                            </div>
                            {errorMessage && <p className="error-message">{errorMessage}</p>}
                            {successMessage && <p className="success-message">{successMessage}</p>}
                            <div className="already-have-account">
                                <p>Already have an account? <a href="/#/login" className="redirect-link">Login</a></p>
                            </div>
                            <button
                                type="submit"
                                className="login-button"
                                disabled={!name || !email}
                            >
                                Register
                            </button>
                        </form>
                    </div>
                    <div className="logo-vc-area">
                        <img src={loginvc} alt="logo_vector" />
                    </div>
                </div>
            </div>
        </GoogleOAuthProvider>
    );
}

export default Register;